export default __webpack_public_path__ + "static/media/landing-finished.65f5b8a3.png";